export const setError = (value: any, callback: (arg: boolean) => void) => {
  if (value.length) {
    callback(false)
  } else {
    callback(true)
  }
}

export const matchEmbededTag = (text: string): string[] | null => text.match(/<blockquote (.*?)>/g)
export const removeTikTagsEmbeded = (text: string) =>
  text.replace(
    /tiktok-embed|https:\/\/www.tiktok.com\/embed.js|<iframe[\s\S]*?>[\s\S]*?<\/iframe>|https:\/\/www.tiktok.com\/video/g,
    ''
  )
